import { DASHBOARD_ENDPOINTS } from '@/consts/api'
import { useDashboardApiClient } from '../useDashboardApiClient'
import type { Domain } from '../types'
import type { WorkspaceType } from '@/modules/workspaces/types'

export const addDomain = ({
    workspaceId,
    workspaceType,
    domain,
}: {
    workspaceId: string
    workspaceType: WorkspaceType
    domain: Domain
}) => {
    return useDashboardApiClient<Record<string, unknown>>({
        url: DASHBOARD_ENDPOINTS.DOMAIN,
        urlParams: { workspaceId, workspaceType },
        method: 'POST',
        data: { domain: domain.domain },
    })
}

export const removeDomain = ({
    workspaceId,
    workspaceType,
    domain,
}: {
    workspaceId: string
    workspaceType: WorkspaceType
    domain: Domain
}) => {
    return useDashboardApiClient<Record<string, unknown>>({
        url: DASHBOARD_ENDPOINTS.DOMAIN_REMOVE,
        urlParams: { workspaceId, workspaceType, domainId: domain.id || '' },
        method: 'DELETE',
    })
}

export const fetchDomains = ({
    workspaceId,
    workspaceType,
}: {
    workspaceId: string
    workspaceType: WorkspaceType
}) => {
    return useDashboardApiClient<Domain[]>({
        url: DASHBOARD_ENDPOINTS.DOMAIN,
        urlParams: { workspaceId, workspaceType },
        method: 'get',
    })
}

export const verifyDomain = ({
    workspaceId,
    workspaceType,
    domainId,
}: {
    workspaceId: string
    workspaceType: WorkspaceType
    domainId: string
}) => {
    return useDashboardApiClient<Domain[]>({
        url: DASHBOARD_ENDPOINTS.DOMAIN_VERIFICATION,
        urlParams: { workspaceId, workspaceType, domainId },
        method: 'get',
    })
}

export const postWorkspaceSecret = (params: {
    workspaceId: string
    workspaceType: WorkspaceType
}) => {
    return useDashboardApiClient<{ newSecret: string }>({
        url: DASHBOARD_ENDPOINTS.SECRET,
        urlParams: params,
        method: 'POST',
    })
}
